import { RouteItem } from '@eastcoal/router/types/route'

import { HOME_PAGE_PATH } from './constants/path'

import { HomePage } from './index'

export const homeRoute: RouteItem = {
  title: '首页',
  path: HOME_PAGE_PATH,
  element: <HomePage />
}
